import { Form, Input, Select, Row, Col, message, Modal, Switch, Drawer, Space, Button, InputNumber } from 'antd';
import { useEffect, useState, useRef } from 'react';
import styles from '../../../index.module.less';
import { getProductSkuList, addActivityProductSkuDetail } from '@/services/product'

const { Option } = Select;

const AddOrEditForm = (props: object) => {
  const [form] = Form.useForm();
  const { id, show, listRef, setVisible, pid, psid } = props;
  const [skuList, setSkuList] = useState([]);

  useEffect(() => {
    getDict();
  }, []);

  const onFinish = async (values) => {
    const data: any = {};
    if (!values.skuId) {
      message.error('请选择活动产品SKU');
      return false;
    }
    data.refProductSkuId = values.skuId;
    data.activityProductId = pid;
    const res: any = await addActivityProductSkuDetail(data);
    if (res.id) {
      message.success('新增成功');
      setVisible(false);
      listRef?.current?.reload();
    }
  };

  const getDict = async () => {
    const res: any = await getProductSkuList({ enabled: true, prodTypes: ["PRODUCT_SINGLE", "PRODUCT_GROUP", "PRODUCT_BASIC_ITEM"] }); // 只查询启用的SKU
    const newSkuList = res?.map((sku: any) => ({ value: sku.id, label: sku.id + '_' + sku.skuName }));
    setSkuList(newSkuList);
  };
  const closeModal = () => {
    setVisible(false);
  };
  const onSubmit = () => {
    form.submit();
  };
  return (
    <Modal
      title={id ? '编辑' : '新增'}
      visible={show}
      onOk={onSubmit}
      onCancel={closeModal}
      width="600px"
      getContainer={false}
      okText="保存"
      destroyOnClose={true}
      cancelText="取消"
    >
      <div className={styles.case_content}>
        <Form preserve={false} className={styles.form_content} name="validate_other" onFinish={onFinish} form={form}>
        <Row>
            <Col span={24}>
              <Form.Item
                name="skuId"
                label="活动产品SKU"
                className={`${styles.case_item} ${styles.case_label_required}`}
              >
                <Select
                  placeholder="请选择"
                  showSearch
                  allowClear
                  className={styles.case_item_select}
                  filterOption={(input, option) =>
                    {
                      return (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                  }
                >
                  {skuList.map((item, index) => (
                    <Option key={item.value} value={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
};

export default AddOrEditForm;
